import React from "react";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  const row = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section className="py-16 md:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-10">
        <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#12b2a0]">
          Lo que dicen
        </span>
        <h2 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-3">
          Resultados que se sienten
        </h2>
      </div>

      <div className="va-marquee relative">
        <div className="va-marquee-track gap-5">
          {row.map((q, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="w-[340px] md:w-[420px] shrink-0 bg-white border border-[#e4dccf] rounded-2xl p-7"
            >
              <p className="font-display text-lg font-semibold leading-snug text-[#2b2a33]">
                {q}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
